"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineViewStates = exports.getViewState = exports.ViewState = void 0;
var ViewState;
(function (ViewState) {
    ViewState[ViewState["IDLE"] = 0] = "IDLE";
    ViewState[ViewState["LOADING"] = 1] = "LOADING";
    ViewState[ViewState["SAVING"] = 2] = "SAVING";
})(ViewState = exports.ViewState || (exports.ViewState = {}));
;
const getViewState = (saving, loading) => {
    if (loading && saving) {
        throw new Error('Cannot be loading and saving at same time');
    }
    else if (loading) {
        return ViewState.LOADING;
    }
    else if (saving) {
        return ViewState.SAVING;
    }
    else {
        return ViewState.IDLE;
    }
};
exports.getViewState = getViewState;
const combineViewStates = (...viewStates) => {
    // Desc order
    const sorted = [...viewStates].sort((a, b) => a > b ? 1 : -1).reverse();
    return sorted[0];
};
exports.combineViewStates = combineViewStates;
//# sourceMappingURL=viewstate.js.map